// extracted by mini-css-extract-plugin
module.exports = {"dateHeader":"DateHeader_dateHeader__2lFTs","backBtn":"DateHeader_backBtn__Iq0AU"};